<form class="pre-form" #formulari="ngForm">            
    <mat-grid-list cols="4" rows="3" rowHeight="80px">                              
        <mat-grid-tile>
                <mat-form-field class="pre-field">
                    <input type="text" name="adreca" matInput placeholder="Adreça" [(ngModel)]="trasllat.alumne.adreca" required i18n-placeholder>
                </mat-form-field>  
        </mat-grid-tile>
        <mat-grid-tile>
                <mat-form-field class="pre-field">
                    <input type="text" name="cp" matInput placeholder="Codi postal" [(ngModel)]="trasllat.alumne.codiPostal" required i18n-placeholder>
                </mat-form-field>  
        </mat-grid-tile>
        <mat-grid-tile>
            <mat-form-field class="pre-field">
                <input matInput name="pais" placeholder="País" [matAutocomplete]="pais" 
                    [formControl]="paisCtrl" [ngModel]="trasllat.alumne.pais" required (ngModelChange)="paisChange($event)" i18n-placeholder>
                <mat-autocomplete #pais="matAutocomplete" [displayWith]="utilitats.displayName">
                    <mat-option *ngFor="let x of filteredPaisos | async" [value]="x">                                        
                        {{ x?.name }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>                            
        </mat-grid-tile>
        <mat-grid-tile *ngIf="trasllat.alumne.paisEspanya()">
            <mat-form-field class="pre-field">
                <input matInput name="poblacio" placeholder="Població" [matAutocomplete]="poblacio" 
                    [formControl]="poblacioCtrl" [ngModel]="trasllat.alumne.poblacio" required (ngModelChange)="poblacioChange($event)" i18n-placeholder>
                <mat-autocomplete #poblacio="matAutocomplete" [displayWith]="utilitats.displayName">
                    <mat-option *ngFor="let x of filteredPoblacions | async" [value]="x">                                        
                        {{ x?.name }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>                            
        </mat-grid-tile>
        <mat-grid-tile *ngIf="!trasllat.alumne.paisEspanya()">
            <mat-form-field class="pre-field">
                <input matInput name="poblacio-naixement-text" placeholder="Població" [(ngModel)]="trasllat.alumne.poblacioText" required i18n-placeholder>
            </mat-form-field>                            
        </mat-grid-tile>                                      
        <mat-grid-tile>
            <mat-form-field class="pre-field">
                <input type="text" name="mobil" matInput placeholder="Mòbil" [(ngModel)]="trasllat.alumne.mobil" required i18n-placeholder>
            </mat-form-field>  
        </mat-grid-tile>
        <mat-grid-tile colspan="2">
            <mat-form-field class="pre-field">
                <input type="email" name="email" matInput placeholder="Correu electrònic" 
                    [(ngModel)]="trasllat.alumne.email" [formControl]="emailInput" required i18n-placeholder>
                <mat-hint i18n>La utilització d'una adreça de Hotmail no garanteix la recepció de correus que la Universitat de Girona us pugui enviar</mat-hint>
                <mat-error i18n>
                    Introdueix una adreça de correu electrònic vàlida!
                </mat-error>
            </mat-form-field>  
        </mat-grid-tile>                     
        <mat-grid-tile colspan="4" *ngIf="trasllat.potModificar">
            <div class="pre-controls-right">
                <button mat-raised-button matStepperPrevious i18n>Torna</button>
                <button mat-raised-button color="primary" (click)="continua()" [disabled]="!isValid()" i18n>Continua</button>            
            </div>
        </mat-grid-tile>
    </mat-grid-list>
</form>


// WEBPACK FOOTER //
// ./src/app/dades-contacte/dades-contacte.component.html